export default function getCroppedImg(imageSrc, crop) {
  return new Promise((resolve, reject) => {
    const image = new window.Image();
    image.crossOrigin = "anonymous";
    image.src = imageSrc;
    image.onload = () => {
      const canvas = document.createElement("canvas");
      canvas.width = crop.width;
      canvas.height = crop.height;
      const ctx = canvas.getContext("2d");

      ctx.drawImage(
        image,
        crop.x,
        crop.y,
        crop.width,
        crop.height,
        0,
        0,
        crop.width,
        crop.height
      );

      // Try WebP first, fallback to PNG if WebP fails
      canvas.toBlob(
        (blob) => {
          if (blob) {
            resolve({ blob, ext: "webp", mime: "image/webp" });
          } else {
            // Fallback to PNG
            canvas.toBlob(
              (pngBlob) => {
                if (pngBlob) {
                  resolve({ blob: pngBlob, ext: "png", mime: "image/png" });
                } else {
                  reject(new Error("Canvas is empty"));
                }
              },
              "image/png"
            );
          }
        },
        "image/webp"
      );
    };
    image.onerror = () => reject(new Error("Failed to load image"));
  });
}